// extracted by mini-css-extract-plugin
export var chip = "_ct-0";
export var filterDropdown = "_ct-5";
export var filterItem = "_ct-6";
export var icon = "_ct-1";
export var removeButton = "_ct-3";
export var removeIcon = "_ct-4";
export var separator = "_ct-2";